import { isEmpty, isNil } from 'lodash/fp'
import z from 'zod'

const FormSchema = z.object({
  No1: z.string({ message: "required" }).min(1, "required"),
  No2: z.string({ message: "required" }).min(1, "required"),
  No3: z.string({ message: "required" }).min(1, "required").regex(/^[\u30A0-\u30FF]+$/, { message: 'must kana' }),
  No4: z.string({ message: "required" }).min(1, "required").regex(/^[\u30A0-\u30FF]+$/, { message: 'must kana' }),
  No5: z.string({ message: "required" }).regex(/\d{7}$/, { message: 'not postalCode' }),
  No6: z.string({ message: "required" }).min(1, "required"),
  No7: z.string({ message: "required" }).min(1, "required"),
  No8: z.string({ message: "required" }).min(1, "required"),
  No9: z.string({ message: "required" }).min(1, "required"),
  No10: z.string({ message: "required" }).regex(/\d+$/, { message: 'must number' }).min(10, { message: 'too small' }).max(11, { message: 'too large' }),
  No11: z.string({ message: "required" }).email({ message: "must email" }),
  No12: z.array(z.enum(["外出登録の設定をしたい", "利用者様の登録情報を変更したい", "緊急連絡先様の登録情報を変更したい", "解約したい", "その他"]), { message: "required" }).refine((data) => !isEmpty(data), "required"),
  No13: z.array(z.string()).optional(),
  No14: z.string().optional(),
  No15: z.string().optional(),
  No16: z.string().regex(/(060|070|080|090)\d{8}$/, { message: 'must mobile' }).optional(),
  No17: z.string().email({ message: "must email" }).optional(),
  No18: z.string().regex(/\d{7}$/, { message: 'not postalCode' }).optional(),
  No19: z.string().optional(),
  No20: z.string().optional(),
  No21: z.string().optional(),
  No22: z.array(z.enum(["同意する"]), { message: "required" }).refine((data) => !isEmpty(data), "required")
})

const CrossCheckSchema = z.object({
  No1: z.string().optional(),
  No2: z.string().optional(),
  No3: z.string().optional(),
  No4: z.string().optional(),
  No5: z.string().optional(),
  No6: z.string().optional(),
  No7: z.string().optional(),
  No8: z.string().optional(),
  No9: z.string().optional(),
  No10: z.string().optional(),
  No11: z.string().optional(),
  No12: z.array(z.enum(["外出登録の設定をしたい", "利用者様の登録情報を変更したい", "緊急連絡先様の登録情報を変更したい", "解約したい", "その他"])).optional(),
  No13: z.array(z.string()).optional(),
  No14: z.string().optional(),
  No15: z.string().optional(),
  No16: z.string().optional(),
  No17: z.string().optional(),
  No18: z.string().optional(),
  No19: z.string().optional(),
  No20: z.string().optional(),
  No21: z.string().optional(),
  No22: z.array(z.enum(["同意する"])).optional(),
}).superRefine((data, ctx) => {
  if (!isNil(data.No12) && !isEmpty(data.No12) && data.No12.includes("外出登録の設定をしたい") && isEmpty(data.No13)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `お問い合わせ内容 が "外出登録の設定をしたい" のときは必須です`,
      path: ["No13"],
    })
  }
  if (!isNil(data.No12) && !isEmpty(data.No12) && data.No12.includes("利用者様の登録情報を変更したい") && isEmpty(data.No14)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `お問い合わせ内容 が "利用者様の登録情報を変更したい" のときは必須です`,
      path: ["No14"],
    })
  }
  if (!isNil(data.No12) && !isEmpty(data.No12) && data.No12.includes("緊急連絡先様の登録情報を変更したい") && isEmpty(data.No15)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `お問い合わせ内容 が "緊急連絡先様の登録情報を変更したい" のときは必須です`,
      path: ["No15"],
    })
  }
  if (!isNil(data.No12) && !isEmpty(data.No12) && data.No12.includes("緊急連絡先様の登録情報を変更したい") && isEmpty(data.No16)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `お問い合わせ内容 が "緊急連絡先様の登録情報を変更したい" のときは必須です`,
      path: ["No16"],
    })
  }
  if (!isNil(data.No12) && !isEmpty(data.No12) && data.No12.includes("緊急連絡先様の登録情報を変更したい") && isEmpty(data.No17)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `お問い合わせ内容 が "緊急連絡先様の登録情報を変更したい" のときは必須です`,
      path: ["No17"],
    })
  }
  if (!isNil(data.No12) && !isEmpty(data.No12) && data.No12.includes("緊急連絡先様の登録情報を変更したい") && isEmpty(data.No18)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `お問い合わせ内容 が "緊急連絡先様の登録情報を変更したい" のときは必須です`,
      path: ["No18"],
    })
  }
  if (!isNil(data.No12) && !isEmpty(data.No12) && data.No12.includes("解約したい") && isEmpty(data.No19)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `お問い合わせ内容 が "解約したい" のときは必須です`,
      path: ["No19"],
    })
  }
  if (!isNil(data.No12) && !isEmpty(data.No12) && data.No12.includes("その他") && isEmpty(data.No21)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `お問い合わせ内容 が "その他" のときは必須です`,
      path: ["No21"],
    })
  }
})

export const FormInputSchema = z.intersection(FormSchema, CrossCheckSchema)